import { Component, useContext } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { TabHeader } from '../TabHeader';
import { NotificationContext, NotificationContextState } from 'context/NotificationContext';
// import { TabSystemUsage } from './SystemUsage/TabSystemUsage';
import { TabPerTenantUsageView } from './PerTenantUsage/TabPerTenantUsageView';
// import { TabTenantsUsageView } from './TenantUsage/TabTenantsUsageView';

import log from 'loglevel';

type DistributorUsagePageState = {
    isLoading: boolean,
    showApiError: boolean    
}

type DistributorUsageInternalProps = {
    notificationContext: NotificationContextState
}

export class DistributorUsageInternal extends Component<DistributorUsageInternalProps, DistributorUsagePageState>  {
    state: DistributorUsagePageState ={
        isLoading: true,
        showApiError: false    
    }

    async componentDidMount() {
        await this.loadPageData();
    }

    loadPageData = async () => {
        try {
            this.setState({
                isLoading: false
            });
        }
        catch (error) {
            log.error(`Something went wrong: ${error}`);
        }
    }
    render() {
        const tabInfos = [
            { name: "Usage", tabId: "0" },
        ]

        let pageHeaderRendered = <h1>Distributor usage</h1>

        return (
            <>
                {pageHeaderRendered}
                <TabHeader tabInfos={tabInfos}>
                    <TabContent>
                        {<>
                            <TabPane tabId="0">
                                <TabPerTenantUsageView />
                            </TabPane>
                        </>}
                    </TabContent>
                </TabHeader>      
            </>
        );
    }
}

// Inject the required contexts.
export const DistributorTenantsUsage = (props: any) => {
    const notificationContext = useContext(NotificationContext);

    return (
        <DistributorUsageInternal {...props} notificationContext={notificationContext} />
    )
}